import React, { createContext, useState } from "react";

export const SurveyContext = createContext();

export const SurveyProvider = ({ children }) => {
    const [surveyTab, setSurveyTab] = useState("surveyManagement");

    return (
        <SurveyContext.Provider
            value={{
                surveyTab,
                setSurveyTab,
            }}
        >
            {children}
        </SurveyContext.Provider>
    );
};
